// extracted by mini-css-extract-plugin
export default {"summary-container":"StockRequestReportSummary_summary-container__lIGcG","summary-ctas":"StockRequestReportSummary_summary-ctas__F9tTD"};